import { Stack, StackProps, SystemStyleObject } from '@mui/system';
import { FC } from 'react';

export const ErrorBlock: FC<StackProps> = ({ children, sx, ...props }) => {
  return (
    <Stack
      sx={(theme) => ({
        border: `1px solid ${theme.palette.error.main}`,
        borderRadius: theme.spacing(1),
        bgcolor: theme.palette.error.superLight,
        color: theme.palette.error.main,
        p: 2,
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
    </Stack>
  );
};
